import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { Company } from './company';
import { ComplianceSetting } from './compliance-setting';

export class CompanyComplianceType extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyComplianceTypeProperties: (
    | {
        property: keyof CompanyComplianceType;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyComplianceType;
        type: 'alias';
      }
    | {
        property: keyof CompanyComplianceType;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'type', type: 'column', dataType: 'string' },
    { property: 'isModifiable', type: 'column', dataType: 'boolean' },
    { property: 'descriptionOfOperations', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Company', model: 'Company', type: 'association' },
    {
      property: 'ComplianceSettings',
      model: 'ComplianceSetting',
      type: 'association'
    }
  ];

  static {
    CompanyComplianceType.CompanyComplianceTypeProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CompanyComplianceType.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CompanyComplianceType.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CompanyComplianceType.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(CompanyComplianceTypeObject: Partial<CompanyComplianceType>) {
    super();

    CompanyComplianceType.CompanyComplianceTypeProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CompanyComplianceTypeObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  CompanyId?: number;
  type?: string;
  isModifiable?: boolean;
  descriptionOfOperations?: string | null;
  createdAt?: Date;
  updatedAt?: Date;

  Company?: Company;
  ComplianceSettings?: ComplianceSetting[];
}
